module.exports = __webpack_public_path__ + "media/public/img/google-ttd-01-ebde2b614e03d07b08eb61e8c902062a.svg";